import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";

import { countryCodes } from "../../config/country-codes";
import regexConfig from "../../config/regex-config";
import { createTeam, editAny } from "../../http/http-calls";
// import { config, S3 } from "aws-sdk";
import { showToast, uploadFileOnServer } from "../../helper-methods";
import { convertUrlToCdn } from "../../helper-methods";
const AddTeamMemberModal = ({
  isOpen,
  toggle,
  fetchTeamMember,
  isEdit,
  editDetails,
}) => {
  //set value in edit mode
  useEffect(() => {
    // console.log("details>>", editDetails)

    if (editDetails !== null) {
      let phoneNumber = editDetails.phone.split("-");
      // console.log(phoneNumber)

      setFormData({
        name: editDetails.lastname
          ? editDetails.firstname + " " + editDetails.lastname
          : editDetails.firstname,
        countryCode: phoneNumber[0],
        phone: phoneNumber[1],
        email: editDetails.email,
        location: editDetails.location,
      });
    }
  }, [editDetails]);

  //state

  const [formData, setFormData] = useState({
    name: "",
    countryCode: "",
    phone: "",
    email: "",
    location: "",
    image: {},
  });
  const [isDirty, setIsDirty] = useState({
    name: false,
    countryCode: false,
    phone: false,
    email: false,
    location: false,
  });
  const [errors, setErrors] = useState({});
  const [img, setImg] = useState();
  const [flag, setFlag] = useState(false);

  const _closeModal = () => {
    toggle();
    setErrors({});
    setFormData({
      name: "",
      countryCode: "",
      phone: "",
      email: "",
      location: "",
      image: {},
    });

    setIsDirty({
      name: false,
      countryCode: false,
      phone: false,
      email: false,
      location: false,
    });
    setImg();
  };

  //photo upload
  // const _onFileChange = async (file) => {
  //   console.log(file)

  //   try {
  //     const res = await awsCredential()
  //     console.log("aws",res)

  //     config.update({
  //       credentials: {
  //         accessKeyId: res.AccessKeyId,
  //         secretAccessKey: res.SecretAccessKey,
  //         sessionToken: res.SessionToken,
  //         AWS_IMAGE_BUCKET_NAME: res.S3BucketName
  //       },
  //       region: "us-east-1"
  //     });

  //     const S3uP = new S3({
  //       apiVersion: "2006-03-01",
  //       params: { Bucket: res.S3BucketName }
  //     });

  //     const Key = String(+new Date());
  //     var params = { Key, ContentType: file.type, Body: file };

  //     S3uP.upload(params, async function(err, data) {
  //       console.log(err, data);
  //       swal({
  //         text: "Photo Successfully Uploaded",
  //         icon: "success",
  //         button: "OK"
  //       })
  //       setPicUrl(data.Location)

  //     });

  //   } catch (error) {
  //     console.log(error)
  //   }

  // }

  //add edit handler
  const _addMemberHandler = async () => {
    const newIsDirty = { ...isDirty };
    Object.keys(isDirty).forEach((each) => (newIsDirty[each] = true));
    const error = _validateForm(formData, newIsDirty);
    // console.log("errors => ", error);
    if (!error) {
      // console.log("no error");
      //api call
      // console.log("data",formData)
      setFlag(true);

      let username = formData.name;
      let code = formData.countryCode;
      let initialPhone = formData.phone;
      let email = formData.email;
      let location = formData.location;
      let phone = code.concat("-", initialPhone);

      let body = { username, phone, email, location };

      if (editDetails) {
        if (img) {
          let payload = [{ uploadData: formData.image }];
          try {
            const res = await uploadFileOnServer(payload);
            // console.log("res >>", res);

            let username = formData.name;
            let code = formData.countryCode;
            let initialPhone = formData.phone;
            let email = formData.email;
            let location = formData.location;
            let phone = code.concat("-", initialPhone);
            let displaypictureurl = res[0].url;

            let editDetail = {
              username,
              phone,
              email,
              location,
              displaypictureurl,
            };

            try {
              const res = await editAny(editDetails._id, editDetail);
              console.log("edited", res);
              fetchTeamMember();
              setFlag(false);
            } catch (error) {
              // console.log(error)
              showToast(error?.reason, "error");
            }
          } catch (error) {
            // console.log("error",error)
          }
        } else {
          try {
            const res = await editAny(editDetails._id, body);
            console.log("edited", res);
            fetchTeamMember();
            setFlag(false);
          } catch (error) {
            // console.log(error)
            showToast(error?.reason, "error");
          }
        }
      } else {
        try {
          const res = await createTeam(body);
          console.log("addTeam", res);
          fetchTeamMember();
          setFlag(false);
        } catch (error) {
          // console.log(error)
          showToast(error?.reason, "error");
        }
      }
      _closeModal();
    }
  };

  //onChnage handler
  const _handelOnChange = (field, event) => {
    const newFormData = { ...formData };
    const newIsDirty = { ...isDirty };

    if (field === "image") {
      newFormData[field] = event.target.files[0];
      setImg(URL.createObjectURL(event.target.files[0]));
    } else {
      newFormData[field] = event.target.value;
    }

    newIsDirty[field] = true;
    setFormData(newFormData);
    setIsDirty(newIsDirty);
    _validateForm(newFormData, newIsDirty);
  };

  //validation form
  const _validateForm = (data, dirties) => {
    const newErrors = { ...errors };

    Object.keys(dirties).forEach((each) => {
      if (each === "name" && dirties[each]) {
        if (!data.name.trim()) {
          newErrors.name = "*Required";
        } else if (
          data.name.trim().length < 2 ||
          data.name.trim().length > 25
        ) {
          newErrors.name =
            "*Name should be greater than 2 characters and less than 25 characters";
        }
        // else if (
        //   data.name.trim().length &&
        //   !new RegExp(regexConfig.name).test(data.name)
        // ) {
        //   newErrors.name = "*Numeric not allowed. Please enter a valid name";
        // }
        else {
          delete newErrors[each];
          dirties[each] = false;
        }
      } else if (each === "phone" && dirties[each]) {
        if (!data.phone.trim()) {
          newErrors.phone = "*Required";
        } else if (
          data.phone.trim().length < 8 ||
          data.phone.trim().length > 12
        ) {
          newErrors.phone = "*Only Numbers allowed min 8 - max 12 characters";
        } else if (
          data.phone.trim().length &&
          !new RegExp(regexConfig.phone).test(data.phone)
        ) {
          newErrors.phone = "*Please enter a valid phone number";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      } else if (each === "countryCode" && dirties[each]) {
        if (!data.countryCode.trim()) {
          newErrors.countryCode = "*Required";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      } else if (each === "email" && dirties[each]) {
        if (!data.email.trim()) {
          newErrors.email = "*Required";
        } else if (data.email.trim().length > 40) {
          newErrors.email = "*Invalid Email";
        } else if (
          data.email.trim().length &&
          !new RegExp(regexConfig.email).test(data.email)
        ) {
          newErrors.email = "*Please enter a valid email ID";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      } else if (each === "location" && dirties[each]) {
        if (!data.location.trim()) {
          newErrors.location = "*Required";
        } else if (
          data.location.trim().length < 2 ||
          data.location.trim().length > 30
        ) {
          newErrors.location =
            "*Location should be greater than 2 character and less than 25 character";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      }
    });
    setIsDirty(dirties);
    setErrors(newErrors);
    return Object.keys(newErrors).length ? true : false;
  };

  const _cancelHandler = () => {
    _closeModal();
  };

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={() => _closeModal()}
      scrollable
      centered
    >
      <ModalHeader toggle={() => _closeModal()}>
        {isEdit ? "Edit Team Member" : "Invite Team Member"}
      </ModalHeader>
      <ModalBody>
        <Row>
          {editDetails ? (
            <Col md={12} className="d-flex justify-content-center mb-4">
              <div className="group_image plus">
                <Input
                  type="file"
                  value=""
                  id="groupImage"
                  className="d-none"
                  accept="image/*"
                  onChange={(event) => _handelOnChange("image", event)}
                />
                <Label for="groupImage" className="mb-0">
                  {editDetails.displaypictureurl ? (
                    <img
                      src={
                        img
                          ? img
                          : convertUrlToCdn(editDetails.displaypictureurl)
                      }
                      alt="category"
                      className="img-fluid"
                      loading="lazy"
                    />
                  ) : (
                    <img
                      src={img ? img : require("../../assets/img/1.png")}
                      alt="category"
                      className="img-fluid"
                      loading="lazy"
                    />
                  )}
                </Label>
              </div>
            </Col>
          ) : null}
          <Col lg={6}>
            <FormGroup>
              <Label>Name</Label>
              <Input
                type="text"
                placeholder="Enter"
                value={formData.name}
                onChange={(event) => _handelOnChange("name", event)}
              />
            </FormGroup>
            {errors.name ? (
              <div className="form-error">{errors.name}</div>
            ) : null}
          </Col>
          <Col lg={6} className="input-group-phone-error">
            <FormGroup>
              <Label>Phone Number</Label>
              <InputGroup className="countryCode flex-nowrap">
                <div>
                  <InputGroupText>
                    <img
                      src={require("../../assets/img/phone.svg").default}
                      alt="user"
                      className="img-fluid"
                    />
                    <Input
                      type="select"
                      className="pl-0"
                      value={formData.countryCode}
                      onChange={(event) =>
                        _handelOnChange("countryCode", event)
                      }
                    >
                      <option>select</option>
                      {countryCodes.map((each) => (
                        <option key={each.code} value={each.dial_code}>
                          {each.code} ({each.dial_code})
                        </option>
                      ))}
                    </Input>
                  </InputGroupText>
                  {errors.countryCode ? (
                    <div className="form-error">{errors.countryCode}</div>
                  ) : null}
                </div>
                <div className="position-relative">
                  <Input
                    type="text"
                    placeholder="Enter"
                    value={formData.phone}
                    autoComplete="off"
                    onChange={(event) => _handelOnChange("phone", event)}
                  />
                  {errors.phone ? (
                    <div className="form-error ms-5">{errors.phone}</div>
                  ) : null}
                </div>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label>Email</Label>
              {isEdit ? (
                <Input
                  type="email"
                  placeholder="Enter"
                  value={formData.email}
                  disabled
                />
              ) : (
                <Input
                  type="email"
                  placeholder="Enter"
                  onChange={(event) => _handelOnChange("email", event)}
                />
              )}
            </FormGroup>
            {errors.email ? (
              <div className="form-error">{errors.email}</div>
            ) : null}
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label>Location</Label>
              <Input
                type="text"
                placeholder="Enter"
                value={formData.location}
                onChange={(event) => _handelOnChange("location", event)}
              />
            </FormGroup>
            {errors.location ? (
              <div className="form-error">{errors.location}</div>
            ) : null}
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          color="link"
          className="closeBtn"
          onClick={() => _cancelHandler()}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => _addMemberHandler()}
          disabled={flag === true}
        >
          {isEdit ? "Update" : "Create"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddTeamMemberModal;
